import { dimensionsOverview } from '@/mocks/site';

export default function Dimensions() {
  return (
    <section id="dimensions" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl">
          <p className="font-label text-xs tracking-[0.25em] text-primary-600 mb-3">
            WHAT WE COMPARE / 对照什么
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
            一部爆料短剧，我们拆成四件事来看
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            宣传语说「根据真实事件改编」，但改编到什么程度、原型是谁、哪些是补白，往往没人讲清楚。这四件事，就是我们每一条档案都要回答的问题。
          </p>
        </div>

        <div className="mt-10 md:mt-14 border-t border-background-200">
          {dimensionsOverview.map((item, idx) => (
            <div
              key={item.title}
              className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-7 md:py-9 border-b border-background-200 hover:bg-background-100/70 transition-colors"
            >
              <div className="md:col-span-5 flex items-start gap-4">
                <span className="font-label text-sm text-foreground-300 pt-1 w-8 shrink-0">
                  {String(idx + 1).padStart(2, '0')}
                </span>
                <div className="flex items-start gap-3">
                  <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-primary-50 text-primary-600 border border-primary-100 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 leading-snug pt-1.5">
                    {item.title}
                  </h3>
                </div>
              </div>

              <div className="md:col-span-7 md:pl-2">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                <ul className="mt-4 flex flex-wrap gap-2">
                  {item.points.map((point) => (
                    <li
                      key={point}
                      className="px-2.5 py-1 rounded-md bg-secondary-50 text-secondary-900 border border-secondary-200 text-xs whitespace-nowrap"
                    >
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}